import type { ModuleMigrationDef } from "@kubdee/sdk";

/**
 * Add Meta `read_insights` to the Facebook Page connector scope set.
 *
 * `pages_read_engagement` is enough for reading Page content/engagement, but
 * post-level Insights metrics such as the new `post_media_view` views metric
 * and `post_clicks` require the Insights permission to be granted on the Page
 * access token. Existing connections must reconnect after this migration.
 */
export const migration: ModuleMigrationDef = {
  key: "013_facebook_page_read_insights_scope",
  version: "0.13.0",
  sql: `
UPDATE \`connectors_types\`
   SET \`oauth_config\` = json_set(
         COALESCE(\`oauth_config\`, '{}'),
         '$.scopes',
         json_array(
           'pages_show_list',
           'pages_manage_posts',
           'pages_read_engagement',
           'read_insights',
           'pages_manage_metadata',
           'pages_read_user_content',
           'pages_manage_engagement',
           'business_management'
         )
       ),
       \`updated_at\` = '2026-05-26T04:45:00Z'
 WHERE \`id\` = 'facebook-page'
   AND (
     COALESCE(json_extract(\`oauth_config\`, '$.scopes[3]'), '') != 'read_insights'
     OR COALESCE(json_extract(\`oauth_config\`, '$.scopes[4]'), '') != 'pages_manage_metadata'
     OR COALESCE(json_extract(\`oauth_config\`, '$.scopes[7]'), '') != 'business_management'
   );
  `.trim(),
};
